/**
 * 工具相关
 */
import request from '@/utils/request';
import JSEncrypt from '@/components/core/common/jsencrypt';
import moment from 'moment';
import {MessageBox} from 'element-ui';
import getErrorMsg from '@/language/getErrorMessage';
import getI18n from '@/vueI18n/getI18n';
import Cookies from 'js-cookie';
import storeLocal from 'store';
import xmail from "../api/api";

/* 文件下载 */
export function downloadFile(url, pm, fileName) {
  request({
    url: url,
    method: 'post',
    responseType:'blob',
    data: pm
  }).then(res=>{
    // let blob = new Blob([res.data], { type: `text/plain;charset=utf-8` });
    let blob = new Blob([res.data]);
    // 获取heads中的filename文件名
    let downloadElement = document.createElement("a");
    // 创建下载的链接
    downloadElement.href = window.URL.createObjectURL(blob);
    // 下载后文件名
    if (fileName) {
      downloadElement.download = fileName;
    } else {
      downloadElement.download = decodeURIComponent(res.headers["download-file-name"] ? res.headers["download-file-name"] : 'file');
    }
    // downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    // 点击下载
    downloadElement.click();         // 下载完成移除元素
    document.body.removeChild(downloadElement);
    // 释放掉blob对象
  });
}
/* 字节单位转换 */
export function sizeToBytes(size) {
  // sizes = ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let temp = size;
  if (size.endsWith('KB')) {
    return parseInt(temp.replace('KB', '')) * 1024
  }else if (size.endsWith('MB')) {
    return parseInt(temp.replace('MB', '')) * 1024 * 1024
  }else if (size.endsWith('GB')) {
    return parseInt(temp.replace('GB', '')) * 1024 * 1024 * 1024
  }else if (size.endsWith('B')) {
    return parseInt(temp.replace('B', ''))
  }else {
    console.log('数值错误')
    return 0
  }
}
export function bytesToSize(bytes) {
  if (isNaN(bytes)) {
    return '';
  }
  let symbols = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let exp = Math.floor(Math.log(bytes)/Math.log(2));
  if (exp < 1) {
    exp = 0;
  }
  let i = Math.floor(exp / 10);
  bytes = bytes / Math.pow(2, 10 * i);

  if (bytes.toString().length > bytes.toFixed(2).toString().length) {
    bytes = bytes.toFixed(2);
  }
  return bytes + ' ' + symbols[i];
}
export function matchAttachIcon(name) {
  let suffix=  name.split('.').pop();
  switch (suffix) {
    case 'doc':
    case 'docx':
      return 'word'
      break;
    case 'jpg':
    case 'png':
    case 'gif':
      return 'img'
      break;
    case 'xls':
    case 'xlsx':
      return 'excel'
      break;
    case 'ppt':
    case 'pptx':
      return 'ppt'
      break;
    case 'html':
      return 'html'
      break;
    case 'zip':
    case 'rar':
      return 'zip'
      break;
    case 'pdf':
      return 'pdf'
      break;
    case 'ai':
      return 'ai'
      break;
    case 'css':
      return 'css'
      break;
    case 'exe':
      return 'exe'
      break;
    case 'mp3':
      return 'mp3'
      break;
    case 'mp4':
      return 'video'
      break;
    case 'js':
    case 'java':
    case 'xml':
      return 'code'
      break;
    case 'txt':
      return 'txt'
      break;
    default:
      return 'unknow'
  }
}
/**
 * RSA非对称加密
 * @param data 需要加密的数据
 */
export function rsaEncrypt(data) {
  // 公钥,，复制前面生成的公钥
  const PUBLIC_KEY = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCiVCam3XwRg7+wpJrd3urtj/QXqYmKP5usEwHXItPRNTrYI2n830A52FI4V5vn+csIXYvLitLb5+jhgJ89pcaJxcjwHLwT02lWrmimjIZK/bbZd0POz0CSGUO5kDAZJoq2YJFIXUkeslIpVGM8eDiO+NcxkT11nlzGPzmRvfLQxQIDAQAB`
  // 使用公钥加密
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(PUBLIC_KEY)
  let result = encrypt.encrypt(data)
  return result
}
/**
 * RSA 解密
 * @param data 需要解密的数据
 */
export function rsaDecrypt(data) {
  //私钥，复制对应的私钥用于解密
  const PRIVATE_KEY = `MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAPKkpQ5wgQ6ADuTq
uhW4R4nhPJEQSoSP7pxvlDVtRZOrrGRLv3xGGoB6/dh4nMOBrYbL1SEjz4PmR9hw
GlDzlNBKRblJTcdtFfWts3IQDPdP8sH4rwJxog3wVzAh1dlKsb1r0GUPdXsIYvGo
Kaf5AuEmSP9LDokhko/VceY3TEwvAgMBAAECgYBF8+2aAhlS4txoZruLM3t8ZrEd
aULygMRb2VczJ/OdJSsoJyZnX5aYX9z7IZqgSqyKZg1l5nsXHbas0XTkzbSi4GyW
7hBaN8XOV+3PYBAeDf8yfDV+GuapVMnKfd8YEnSdDGbUTBlF5eSJ2jWGhYbxKMNU
kEOYRMLDFMQlfLFEIQJBAP1zwt1wKGXXap0n5mS53jvPECWK6fEcESdN+OJwnF1F
qkMIQJZ+FpaBkp/MildYuvBBpIiaASdpqMvcH0+2MpcCQQD1FRE9dKM6FLOUnxDj
Lnx5f4ZrwqUjYBLL+Xs3ItH5viLO+pcrCWm2mKtVAcGy7wZEDyQUiNkNHWNDemB8
454pAkAMf8j8YqubWiRH28/g58mt6WhCcbdXzKqL5ayAfk03zFe5No743P8ALSOt
/chUxmtxrcsPcYjdCLjqVNC2faXBAkBTiu7piAzsC4p7qw1So9ICiJoFucAZIvLF
XTHHRbNV8p5i98D4BqlmePxOad7hY+E66f5ekZeLhO0FX33slJqhAkEAmuJGiFs5
mYq0JwRRG36D3mNhgOEgrUoAvOLlQ1Yctva7aXwrS97+zEoCUP7vMA36BJop3wTG
6ETVGyMemmiSjw==`
  //使用私钥解密
  const decrypt = new JSEncrypt()
  decrypt.setPrivateKey(PRIVATE_KEY)
  let result = decrypt.decrypt(data)
  return result
}
/**
 * momentJs 日期时间格式化
 * @param date
 */
export function formatDate(val) {
  const configLanguage = getConfigLanguage();
  let isCurrYear = moment().year() === new Date(val).getFullYear();
  let lDay = '';
  let nDay = '';
  let sDay = '';
  let langType = configLanguage || 'cn';
  switch (langType) {
    case 'cn':
      lDay = '昨天';
      nDay = '明天';
      sDay = '今天';
      break;
    case 'en':
      lDay = 'Yesterday';
      nDay = 'Tomorrow';
      sDay = 'Today';
      break;
    case 'hk':
      lDay = '昨天';
      nDay = '明天';
      sDay = '今天';
      break;
  }
  moment.locale("fr", {
    calendar: {
      lastDay: "["+ lDay +"] HH:mm:ss",
      lastWeek: "MM-DD HH:mm:ss",
      nextDay: "["+ nDay +"] HH:mm:ss",
      nextWeek: "MM-DD HH:mm:ss",
      sameDay: "["+ sDay +"] HH:mm:ss",
      sameElse: function () {
        if (isCurrYear) {
          return "MM-DD HH:mm:ss";
        } else {
          return "YYYY-MM-DD HH:mm:ss";
        }
      }

    },
  });
  return moment(val).calendar();
}
/**
 * bitIs1权限位方法
 * @param number-后端权限值 pos-对应权限位
 *  return 当前对应位的功能权限Boolean
 */
export function bitIs1(number, pos) {
  // console.log(number);
  number = number.toString();
  let arr = [];
  let remainder,i,str2,num,char;
  while(number.length>0) {
    str2 = "";remainder=0;
    for(i=0;i<number.length;i++) { // str2 = str组成的十进制数 / 2
      num = number.charCodeAt(i)-0x30; // num to String
      num = remainder*10 + num;
      char = Math.floor(num/2).toString();
      // 忽略最高为的0 ， 即最高为如果是 0 则不放入 str2
      if(!(char === "0" && str2 === "")) { str2 += char;}
      remainder = num%2;
    }
    number = str2;
    arr.push(remainder); // 保存余数
  }
  let bitNubmer = arr.reverse().join('');
  try{
    let bitstr = bitNubmer.split("").reverse().join("");
    return bitstr.charAt(pos - 1) === "1";
  }catch(e){
  }
  return false;
}
/**
 * loadJs 引入远程js方法
 * @param src
 */
export function loadJs(src) {
  return new Promise((resolve,reject)=>{
    let script = document.createElement('script');
    script.type = "text/javascript";
    script.src= src;
    document.body.appendChild(script);

    script.onload = ()=>{
      resolve();
    }
    script.onerror = ()=>{
      reject();
    }
  })
}
/**
 * emailPart 邮件格式部分提取
 * @param emailStr part
 */
export function emailPart(emailStr, part) {
  let isFull = emailStr.indexOf("<") !== -1 && emailStr.indexOf(">") !== -1;
  let addr = '', name = '';
  if( isFull ){
    name = emailStr.split('<')[0];
    addr = emailStr.split('<')[1];
    addr = addr.substring(0,addr.length-1);
  } else {
    addr = emailStr;
  }
  if(part === 'email') {
    return addr
  } else if('name') {
    return name
  } else {
    return addr
  }
}
/**
 * 错误弹框
 * @param res
 */
export function errorAlert(res){
  let alertHtml = '<h3 style="line-height:24px; color: #24324c;">' + getErrorMsg(res.data) + '</h3>';
  alertHtml += '<div style="font-size:12px; margin:20px 20px 20px 0; line-height:21px; color:#24324c;">code: ' + res.data.code + ', host: ' + res.data.host
      + ', time: ' + moment.unix(res.data.time / 1000).format("YYYY-MM-DD HH:mm:ss") + ', traceId: ' + res.data.traceId + ' </div>';
  MessageBox.alert(alertHtml, getI18n.t('wm_lang_c45357'), {dangerouslyUseHTMLString: true});
}

/**
 * 子文件所属的根文件夹ID
 * @param fid:子文件夹id  folders:文件夹数组
 */
export function belongRootFolderId(fid, folders) {
  let currFolder = folders.find((item)=> {
    return item.folderId === fid;
  });
  if (!currFolder) {
    return;
  }
  if(currFolder.parentFolderId !== 0) {
    return belongRootFolderId(currFolder.parentFolderId, folders);
  } else {
    return currFolder.folderId;
  }
}

/**
 * 获取localstorge中的多语言
 */
export function getConfigLanguage() {
  let configSetting = storeLocal.get('Pwm-configSetting');
  let configLanguage = '';
  if (!configSetting) {
    return
  }
  switch (configSetting.displaySetting.language) {
    case xmail.enums.Language.CN:
      configLanguage = 'cn';
      break;
    case xmail.enums.Language.EN:
      configLanguage = 'en';
      break;
    case xmail.enums.Language.HK:
      configLanguage = 'hk';
      break;
    default:
      configLanguage = '';
  }
  return configLanguage;
}
/**
 * 构造文件夹全路径
 * * @param data:文件夹数组
 */
export function getFolderPathName(data) {
  const folders = [];
  if (!data.length) {
    return [];
  }
  let parentNamePath = (data, curr) => {
    let name = curr.displayName;
    // console.log(name)
    let getFullPath = (folder, data) => {
      if (data.length === 0) {
        return;
      }
      let parentFolder = data.find(item =>{
        return item.folderId === folder.parentFolderId
      });
      // console.log(parentFolder)
      if(parentFolder) {
        name = parentFolder.displayName +'/'+ name;
        if (parentFolder.parentFolderId !== 0) {
          getFullPath(parentFolder, data);
        }
      }
    };
    getFullPath(curr, data);
    return name
  };
  for (let i = 0; i < data.length; i++) {
    let obj = JSON.parse(JSON.stringify(data[i]));
    if (data[i].parentFolderId !== 0) {
      // let fullPathName = this.parentNamePath(data, data[i]);
      let fullPathName = parentNamePath(data, data[i]);
      // console.log(fullPathName);
      obj.displayName = fullPathName;
    }
    folders.push(obj);
  }
  return folders;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js